import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import {
  Button,
  TextField as TextFieldMUI,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Grid,
  Popper,
  FormHelperText,
  Typography,
  CircularProgress,
} from "@mui/material";
import { TextField, Switch, fieldToTextField } from "formik-mui";
import { useSelector, useDispatch } from "react-redux";
import { Autocomplete } from "formik-mui";
import { useSnackbar } from "notistack";

import layout, { addOrEditMenuItem } from "../../../../store/ducks/duckMenuItem";
import iconsName from "../../../../constants/icons";
import { useUser } from "../../../../auth/UserProvider";
import FormikAutocompleteMenuItem from "../../../../components/FormikAutocompleteMenuItem";
import { BorderLinearProgress } from "../../../../components/LoadingComponent";

import MenuItemCollectionForm from "./MenuItemCollectionForm";

const stylesPopper = (_theme) => ({
  popper: {
    // maxWidth: "10",
    overFlowX: "hidden",
  },
});

const PopperMy = function (props) {
  return <Popper {...props} placement="bottom-start" style={stylesPopper.popper} />;
};

export const FormikAutocompleteLayouts = ({ textFieldProps, ...props }) => {
  const loading = useSelector((state) => state.layout.isLoading);
  const paths = useSelector((state) => state.sidebar.paths);
  const layouts = useSelector((state) =>
    state.layout.dataLayout.map(({ id, name }) => ({ id, name })),
  );

  const {
    form: { setTouched, setFieldValue },
  } = props;
  const { error, helperText, ...field } = fieldToTextField(props);
  const { name, value } = field;

  const getName = (id) => layouts.find((x) => x.id === id)?.name ?? "";

  const layoutName = getName(value);

  return (
    <Autocomplete
      {...props}
      {...field}
      PopperComponent={PopperMy}
      defaultValue={layoutName}
      getOptionLabel={(optionId) => getName(optionId)}
      inputMode={"search"}
      loading={loading}
      renderInput={(props) => (
        <TextFieldMUI
          {...props}
          {...textFieldProps}
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {props.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          error={error}
          helperText={helperText}
        />
      )}
      renderOption={(value, _state) => (
        <Typography noWrap>
          {getName(value)}
          {paths[value] && (
            <Typography noWrap color="textSecondary">
              {paths[value]}
            </Typography>
          )}
        </Typography>
      )}
      onBlur={(e) => {
        e.preventDefault();
        setTouched({ [name]: true });
      }}
      onChange={(_, valueOnChange) => setFieldValue(name, valueOnChange)}
      onInputChange={(_, valueInput, reason) => {
        if (reason === "input") {
        }
      }}
    />
  );
};

const FormikAutocompleteGroups = ({ textFieldProps, ...props }) => {
  const groupIds = useSelector((state) => {
    let groupsSimplified = state.groups.data.map(({ id, name }) => ({ id, name }));

    groupsSimplified.filter((x) => !x.deleted);

    groupsSimplified.sort((a, b) => (a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0));
    groupsSimplified = groupsSimplified.map((x) => x.id);

    return groupsSimplified;
  });

  const { data: groups, isLoading: loading } = useSelector((state) => state.groups);

  const getName = (id) => groups.find((x) => x.id === id)?.name ?? "";
  const getGroup = (id) => groups.find((x) => x.id === id) ?? { name: "", description: "" };

  const {
    form: { setTouched, setFieldValue },
  } = props;
  const { error, helperText, ...field } = fieldToTextField(props);
  const { name } = field;

  return (
    <Autocomplete
      {...props}
      {...field}
      getOptionLabel={(option) => getName(option)}
      // disableListWrap
      limitTags={1}
      loading={loading}
      options={groupIds}
      renderInput={(props) => (
        <TextFieldMUI
          {...props}
          {...textFieldProps}
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {props.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          error={error}
          helperText={helperText}
        />
      )}
      renderOption={(value, _state) => {
        let { name, description } = getGroup(value);

        return (
          <Typography>
            {name}
            <Typography color="textSecondary">{description}</Typography>
          </Typography>
        );
      }}
      onBlur={() => setTouched({ [name]: true })}
      onChange={(_, value) => setFieldValue(name, value)}
    />
  );
};

const MenuItemForm = (props) => {
  const { initialValues, isEdit, handleClose, open } = props;

  const layouts = useSelector((state) => {
    let layoutSimplified = state.layout.dataLayout.map(({ id, name }) => ({
      id,
      name,
    }));

    layoutSimplified.sort((a, b) => (a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0));

    layoutSimplified = layoutSimplified.map((x) => x.id);

    return layoutSimplified;
  });

  function valInitialCollection(element) {
    let response = element.collection;

    if (typeof element.collection !== "undefined") {
      response = element.collection.filter((item) => !item.deleted);
    }

    return response;
  }
  const [collection, setCollection] = useState(valInitialCollection(initialValues));

  const { isAdmin } = useUser();

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  useEffect(() => {
    if (collection && collection.lenght > 0) {
      setCollection(collection.collection.map(({ childrenId }) => ({ childrenId })));
    }
  }, [collection]);

  return (
    <>
      <Formik
        initialValues={initialValues}
        validate={(values) => {
          let errors = {};

          if (!values.name) {
            errors.name = "Required";
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          values = {
            ...values,
            layoutId: values.layoutId === 0 ? null : values.layoutId,
            collection: collection ? collection : null,
          };
          let message = values.id > 0 ? "Edited" : "Added";

          // eslint-disable-next-line no-console
          console.log("Submitting menu item add/edit", values);

          return dispatch(
            addOrEditMenuItem(values, () => {
              setSubmitting(false);
            }),
          ).then(() => {
            handleClose();
            enqueueSnackbar(`${message} '${values.name}' MenuItem Successfully`, {
              variant: "success",
            });
          });
        }}
      >
        {({ submitForm, isSubmitting, values }) => (
          <Form>
            <Dialog
              fullWidth
              aria-labelledby="form-dialog-title"
              maxWidth="sm"
              open={open}
              onClose={handleClose}
            >
              {isSubmitting && <BorderLinearProgress />}
              <DialogTitle id="form-dialog-title">
                {isEdit && initialValues?.id !== 0
                  ? "Edit"
                  : !isEdit && initialValues?.id !== 0
                    ? "Details"
                    : "Add"}
                {initialValues.isCollection && " Collection"}
                {initialValues.deleted && isAdmin && (
                  <>
                    <FormControlLabel
                      control={
                        <Field color="primary" component={Switch} name="deleted" type="checkbox" />
                      }
                      label="Deleted"
                      labelPlacement="start"
                      style={{ marginRight: 0, marginLeft: "70%" }}
                    />
                    <FormHelperText
                      style={{
                        marginRight: "5%",
                        textAlign: "right",
                      }}
                    >
                      {values?.deleted ? "Enable" : "Disable"}
                    </FormHelperText>
                  </>
                )}
              </DialogTitle>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Field
                        fullWidth
                        component={TextField}
                        label="Name"
                        margin="dense"
                        name="name"
                        type="text"
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Field
                        component={TextField}
                        label="Order"
                        margin="dense"
                        name="order"
                        type="number"
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Field
                        freeSolo
                        fullWidth
                        PopperComponent={PopperMy}
                        component={Autocomplete}
                        margin="dense"
                        name="icon"
                        options={iconsName}
                        renderInput={(params) => (
                          <TextFieldMUI
                            {...params}
                            label="Icon"
                            margin="dense"
                            style={{ maxHeigth: 39 }}
                            variant="outlined"
                          />
                        )}
                        style={{ maxHeigth: 39 }}
                      />
                    </Grid>
                    <Grid item style={{ paddingTop: 23, textAlign: "center" }} xs={2}>
                      {values.icon !== "" ? (
                        <i className="material-icons">{values.icon}</i>
                      ) : (
                        <>{"Preview"}</>
                      )}
                    </Grid>
                  </Grid>

                  {!values.isCollection && (
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <Field
                          component={FormikAutocompleteMenuItem}
                          disabled={values.deleted}
                          margin="dense"
                          name="parentMenuItemId"
                          style={{ width: "100%", height: "100%" }}
                          textFieldProps={{
                            fullWidth: true,
                            margin: "dense",
                            variant: "outlined",
                            label: "Parent Menu Item",
                          }}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Field
                          component={FormikAutocompleteLayouts}
                          disabled={values.deleted}
                          margin="dense"
                          name="layoutId"
                          options={layouts}
                          style={{ width: "100%", height: "100%" }}
                          textFieldProps={{
                            fullWidth: true,
                            margin: "dense",
                            variant: "outlined",
                            label: "Layout",
                          }}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  )}
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Field
                        fullWidth
                        multiline
                        component={TextField}
                        label="Description"
                        margin="dense"
                        name="description"
                        rows={2}
                        type="text"
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  {!values.isCollection && (
                    <>
                      <Grid container spacing={1} style={{ marginTop: 10 }}>
                        <Grid item xs={3}>
                          <FormControlLabel
                            control={
                              <Field
                                color="primary"
                                component={Switch}
                                name="public"
                                type="checkbox"
                              />
                            }
                            label="Public"
                            labelPlacement="start"
                          />
                        </Grid>
                        <Grid item xs={9}>
                          {values.id !== 0 && !values.public && (
                            <Field
                              multiple
                              component={FormikAutocompleteGroups}
                              disabled={values.deleted}
                              margin="dense"
                              name="groups"
                              style={{ width: "100%", height: "100%" }}
                              textFieldProps={{
                                fullWidth: true,
                                margin: "dense",
                                variant: "outlined",
                                label: "Groups",
                              }}
                              variant="outlined"
                            />
                          )}
                        </Grid>
                      </Grid>

                      <Grid container spacing={1} style={{ marginTop: 10 }}>
                        <Grid item xs={3}>
                          <FormControlLabel
                            control={
                              <Field
                                color="primary"
                                component={Switch}
                                name="isInternal"
                                type="checkbox"
                              />
                            }
                            label="Internal"
                            labelPlacement="start"
                          />
                        </Grid>
                        <Grid item xs={9}>
                          {values.isInternal && (
                            <Field
                              fullWidth
                              multiline
                              component={TextField}
                              label="Internal link"
                              margin="dense"
                              name="internalLink"
                              rows={2}
                              type="text"
                              variant="outlined"
                            />
                          )}
                        </Grid>
                      </Grid>
                    </>
                  )}
                  {values.isCollection && (
                    <MenuItemCollectionForm collection={collection} setCollection={setCollection} />
                  )}
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button color="primary" variant="contained" onClick={handleClose}>
                  Close
                </Button>
                {isEdit && (
                  <Button color="primary" variant="contained" onClick={submitForm}>
                    Save
                  </Button>
                )}
              </DialogActions>
            </Dialog>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default MenuItemForm;
